'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useRef, useMemo, Children, isValidElement, cloneElement } from 'react';
import { BreadcrumbList } from './breadcrumb-list.component.js';
import { useId } from '../../hooks/use-id.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(r, e) {
    if (null == r) return {};
    var t, o, n = _object_without_properties_loose(r, e);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(r);
        for(o = 0; o < c.length; o++)t = c[o], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(r, t) && (n[t] = r[t]);
    }
    return n;
}
function _object_without_properties_loose(r, e) {
    if (null == r) return {};
    var t, o, n = {}, c = Object.keys(r);
    for(o = 0; o < c.length; o++)t = c[o], e.indexOf(t) >= 0 || (n[t] = r[t]);
    return n;
}
let m = new Set([
    'swan-breadcrumbs'
]);
const Breadcrumbs = renderWithRef('Breadcrumbs', null, (a, b)=>{
    var { accessibleTextForMore: d, children: f } = a, h = _object_without_properties(a, [
        "accessibleTextForMore",
        "children"
    ]);
    let [_, w] = useState(false), j = useId(), x = useRef(void 0), y = useMemo(()=>Children.map(f, (r, e)=>{
            if (isValidElement(r)) {
                let t = r.props.id || (null != j ? j : 'breadcrumb-') + e;
                return 1 === e ? cloneElement(r, {
                    id: t,
                    ref: x
                }) : cloneElement(r, {
                    id: t
                });
            }
            return r;
        }), [
        f,
        j
    ]), O = Children.toArray(y), v = O.map((r)=>isValidElement(r) ? r.props.id : null);
    function showMore() {
        w(true), setTimeout(()=>{
            if (void 0 === x.current) return;
            let r = x.current;
            r.children && r.children.length > 0 && r.children[0].focus();
        }, 500);
    }
    return jsx(RenderComp, {
        root: "nav",
        forwardedRef: b,
        classNames: m,
        props: h,
        children: d && v.length > 4 ? jsxs(BreadcrumbList, {
            className: _ ? '' : 'swan-breadcrumbs-collapsed',
            children: [
                O[0],
                jsx("li", {
                    className: "swan-breadcrumbs-button-more",
                    children: jsx("button", {
                        "aria-label": d,
                        "aria-expanded": "false",
                        onClick: showMore,
                        "aria-controls": v.slice(1, -2).join(' '),
                        children: "..."
                    })
                }),
                O.slice(1)
            ]
        }) : jsx(BreadcrumbList, {
            children: y
        })
    });
});

export { Breadcrumbs };
